import { useEffect, useState } from 'react';

import axios from 'axios';

const TIK_TOK_BASE_URL = 'https://www.tiktok.com';
const TIK_TOK_EMBED_URL = 'https://www.tiktok.com/oembed';

const useTikTokPost = (post_id: string) => {
  const [scriptSrc, setScriptSrc] = useState(null);
  const [html, setHtml] = useState(null);
  useEffect(() => {
    fetchTikTokEmbed();
  }, []);

  const fetchTikTokEmbed = async () => {
    const embed = await axios.get(`${TIK_TOK_EMBED_URL}?url=${TIK_TOK_BASE_URL}/${post_id}`);

    const htmlString = embed.data.html;
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;

    const scriptTag = tempElement.getElementsByTagName('script')[0];

    setScriptSrc(scriptTag && scriptTag.src);
    setHtml(htmlString.substr(0, htmlString.indexOf('<script')));
  };

  return { html, scriptSrc };
};

export { useTikTokPost };
